import React, { useState, useEffect, useRef } from "react";
import { Select, Button, Row, Col, Card } from "antd";
import { Line, Chart } from "react-chartjs-2";
import zoom from "chartjs-plugin-zoom";
import { FormattedMessage, useIntl } from "react-intl";
import styled from "styled-components";
import { useSelector } from "react-redux";

import translations from "../../../lib/translations/nodeTranslations";
import { selectors as NODE_LIVE_STATS_SELECTORS } from "../../../ducks/nodeLiveStats";

const { Option } = Select;

const StatisticsGraph = ({ data, channelId, type, codecId, streamId }) => {
  const statRef = useRef(null);
  const { formatMessage } = useIntl();
  useEffect(() => {
    Chart.plugins.register(zoom);
  }, []);

  const handleResetZoom = () => {
    statRef.current.chartInstance.resetZoom();
  };

  const parseStatisticName = (statisticName) => {
    const translationExist = statisticName in translations;

    return translationExist ? formatMessage(translations[statisticName]) : statisticName;
  };

  const selectorData = useSelector((state) =>
    NODE_LIVE_STATS_SELECTORS.getSelectedStatsTypes({ state, channelId, type })
  );

  const [selectedStat, setSelectedStat] = useState(selectorData[0]);
  const { data: filteredData, labels: filteredLabels } = useSelector(() =>
    NODE_LIVE_STATS_SELECTORS.getSelectedStatistics({ selectedStat, type, data, codecId, streamId })
  );

  const handleChange = (selectedValue) => {
    setSelectedStat(selectedValue);
    handleResetZoom();
  };

  const options = {
    pan: {
      enabled: true,
      mode: "yx",
    },
    zoom: {
      enabled: true,
      mode: "x",
    },
  };

  const parsedData = {
    labels: filteredLabels,
    datasets: [
      {
        label: parseStatisticName(selectedStat),
        fill: false,
        lineTension: 0.1,
        backgroundColor: "rgba(75,192,192,0.4)",
        borderColor: "rgba(75,192,192,1)",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "rgba(75,192,192,1)",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgba(75,192,192,1)",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: filteredData,
      },
    ],
  };

  return (
    <StyledCard title={<FormattedMessage id="StatisticsGraph.title" defaultMessage="Statistics chart" />}>
      <Row type="flex" justify="space-between">
        <Col>
          <FormattedMessage id="StatisticsGraph.selectStatistic" defaultMessage="Select statistic:" />{" "}
          <Select onChange={handleChange} style={{ width: 250 }} defaultValue={selectedStat}>
            {selectorData.map((statisticName) => (
              <Option key={statisticName}>{parseStatisticName(statisticName)}</Option>
            ))}
          </Select>
        </Col>
        <Col>
          <Button type="primary" onClick={handleResetZoom}>
            <FormattedMessage id="StatisticsGraph.resetZoom" defaultMessage="Reset zoom" />
          </Button>
        </Col>
      </Row>
      <Line data={parsedData} options={options} ref={statRef} />
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  margin-bottom: 10px;
`;

export default StatisticsGraph;
